import React from "react";

const CameraExplanations = () => {
  return (
    <div>
      <h4>How to use the protein viewer camera</h4>
      <ul className="tw-list-disc">
        <li>
          Use the <b>left</b> mouse button for rotation.
        </li>
        <li>
          Use the <b>right</b> mouse button for panning.
        </li>
        <li>
          Use the mouse <b>wheel</b> for zooming in / out.
        </li>
        <li>
          Use left mouse button <b>double-click</b> to autofocus.
        </li>
      </ul>
    </div>
  );
};

export default CameraExplanations;
